(function ($) {
    'use strict';

    $(document).ready(function () {
        $('.bloc_comparateur').each(function () {
            const slider = $(".sliderBeforeAfter")
            const sliderWidth = slider.outerWidth()
            const before = slider.find(".contBefore")
            const dragger = slider.find(".dragger")

            const maxScrollX = sliderWidth / 2
            let targetX = maxScrollX
            let currentX = 0
            let isDragging = false

            // --- Clip-path helpers ---

            function setClipPath(x) {
                before.css("clip-path", `inset(0px ${sliderWidth - x}px 0px 0px)`)
            }

            function setDraggerX(x) {
                dragger.css("transform", `translate3d(${x}px, 0px, 0px)`)
                currentX = x
            }

            // Init
            setClipPath(0)
            setDraggerX(0)

            // --- Drag (mouse + touch) ---

            let dragStartMouseX = 0
            let dragStartX = 0

            function onPointerDown(e) {
                isDragging = true
                const point = e.touches ? e.touches[0] : e
                dragStartMouseX = point.clientX
                dragStartX = currentX
                dragger.css("transition", "none")
                before.css("transition", "none")
            }

            function onPointerMove(e) {
                if (!isDragging) return
                e.preventDefault()
                const point = e.touches ? e.touches[0] : e
                const delta = point.clientX - dragStartMouseX
                const x = Math.max(0, Math.min(dragStartX + delta, sliderWidth))
                setDraggerX(x)
                setClipPath(x)
            }

            function onPointerUp() {
                if (!isDragging) return
                isDragging = false

                const progress = getScrollProgress()
                if (progress > 0.01) {
                    targetX = currentX / progress
                }
            }

            dragger.on("mousedown touchstart", onPointerDown)
            $(document).on("mousemove touchmove", onPointerMove)
            $(document).on("mouseup touchend", onPointerUp)

            // --- Scroll-driven animation ---

            function getScrollProgress() {
                const rect = slider[0].getBoundingClientRect()
                const winH = window.innerHeight
                const start = winH * 0.9
                const end = winH * 0.6
                const top = rect.top
                const raw = (start - top) / (start - end)
                return Math.max(0, Math.min(raw, 1))
            }

            let prevProgress = 0

            $(window).on("scroll", function () {
                if (isDragging) return

                const progress = getScrollProgress()

                // Reset targetX when scrolling back above trigger zone
                if (progress <= 0 && prevProgress > 0) {
                    targetX = maxScrollX
                }

                const x = Math.min(progress * targetX, sliderWidth)

                dragger.css("transition", "transform 1s ease")
                before.css("transition", "clip-path 1s ease")

                setDraggerX(x)
                setClipPath(x)

                prevProgress = progress
            })

        });
    });
})(jQuery);
